import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel } from '@mui/material';
import { Controller } from 'react-hook-form';


const ReactCheckBox = (props) => {
    const {
        hookFormControl,
        label,
        formLabel,
        varName,
        disabled = false,
        errorMessage = null,
        size = "small",
        variant = "outlined",
        width = '100%',
    } = props;

    return (
        <>
            <FormControl error={errorMessage !== null} sx={{ width }} size={size} variant={variant}>
                {formLabel && (
                    <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">{formLabel}</FormLabel>
                )}
                <Controller
                    name={varName}
                    control={hookFormControl}
                    render={({ field }) => (
                        <FormControlLabel 
                            disabled={disabled} 
                            control={
                                <Checkbox  
                                    checked={field.value} 
                                    {...field} 
                                    sx={{
                                        color: '#000',
                                        '&.Mui-checked': {
                                            color: '#000',
                                        },
                                    }}
                                />
                            }
                            className="font-['Poppins-Regular'] text-[15px]"
                            label={label}
                        />
                    )}
                />
                {errorMessage && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular']" id="component-error-text">
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default ReactCheckBox;
